module.exports = __webpack_public_path__ + "static/media/headset_icon.40185816.svg";